import { useCallback } from "react";
import type {
    FleetAuthenticatePeriodSortKey,
    SortDirection,
    FleetAuthenticatePeriod,
    PageInfo,
} from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";
import { defaultPageSize } from "../../../utils/constants";

export const useFleetAuthenticationPeriods = ({
    dateStart,
    dateEnd,
    sortDirection,
    sortKey,
    page,
}: {
    dateStart: Date;
    dateEnd: Date;
    sortDirection?: SortDirection;
    sortKey?: FleetAuthenticatePeriodSortKey;
    page?: number;
}): UseFetchActionReturn<FleetAuthenticatePeriod[] | undefined> => {
    const fetchPeriods: () => Promise<FleetAuthenticatePeriod[] | undefined> = useCallback(() => {
        return store.fleetAuthenticateEventsApi.fleetAuthenticateEventsListFleetAuthenticatePeriods(
            {
                dateStart,
                dateEnd,
                pageSize: defaultPageSize,
                sortDirection,
                sortKey,
                page,
            },
        );
    }, [dateStart, dateEnd, sortDirection, sortKey, page]);
    return useFetchAction(fetchPeriods);
};

export const useFleetAuthenticationPeriodsMetadata = ({
    dateStart,
    dateEnd,
}: {
    dateStart: Date;
    dateEnd: Date;
}): UseFetchActionReturn<PageInfo> => {
    const fetchEventsMetaData: () => Promise<PageInfo> = useCallback(() => {
        return store.fleetAuthenticateEventsApi.fleetAuthenticateEventsListFleetAuthenticatePeriodsMetadata(
            {
                dateStart,
                dateEnd,
                pageSize: defaultPageSize,
            },
        );
    }, [dateStart, dateEnd]);
    return useFetchAction(fetchEventsMetaData);
};
